import "font-awesome/css/font-awesome.css";
import "babel-polyfill";
import "es6-shim";
import './app.scss';
import * as ReactDOM from 'react-dom';
import * as React from 'react';
import { Provider } from 'react-redux';
import { configureStore } from "./store/";
import "whatwg-fetch";
import { OnUpdate } from "rrc";
import { combineReducers } from "redux";
import Notifications, { notify } from 'react-notify-toast';

import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import Home from './pages/Home';
import CREFooter from './pages/CREFooter';
//import CREHeader from './pages/CREHeader';
import CREHeaderContainer from './pages/CREHeader';
import Involved from './pages/Involved';
import Research from './pages/Research';
import ResearchDetail from './pages/ResearchDetail';
import Resources from './pages/Resources';
import Publications from './components/Publications/Publications';
import PublicationsContainer from './components/Publications/Publications';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import UnderConstruction from './pages/UnderConstruction';
import DiscussionBoardContainer from './components/DiscussionBoard/Container';
import { Partners } from './pages/People1';
import { AboutLogo, Mission } from './pages/Mission';
import OurTeamContainer from './components/People/OurTeam';
import IndigenousAdvisoryGroupContainer from './components/People/IndigenousAdvisoryGroup';
import NewsContainer from './components/news/NewsContainer';
import AdministrationContainer from './components/Administration/AdministrationContainer';
import ResearchItemContainer from './components/Research/ResearchItem';
import ResearchContainer from './components/Research/Research';
import ResourceItemContainer from './components/Resources/ResourceItem';
import ResourcesContainer from './components/Resources/ResourcesGrid';
import ContactUsContainer from './components/ContactUs/ContactUs';
import CALDAdvisoryGroupContainer from './components/People/CALDAdvisoryGroup';
import YouthAdvisoryGroupContainer from './components/People/YouthAdvisoryGroup';
import ConsumerAdvisoryGroupContainer from './components/People/ConsumerAdvisoryGroup';
import AboutUsContainer from './components/AboutUs/AboutUs';
import AdvisoryGroupsContainer from './components/AboutUs/AdvisoryGroups';

import discussionBoard from './reducers/discussionBoard';
import siteData from './reducers/siteData';
import people from './reducers/people';
import notification from './reducers/notification';
import news from './reducers/news';
import research from './reducers/research';
import publications from './reducers/publications';
import homeSettings from './reducers/homeSettings';
import aboutUsSettings from './reducers/aboutUsSettings';
import contactUsSettings from './reducers/contactUsSettings';

import { rootEpic } from './epics';
import * as Tracking from './helpers/analytics';
import { siteDataRequest } from './actions/sitedata.actions';
import { AppSettings } from './helpers/AppSettings';





Tracking.initGa();

class App extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {

        //if (AppSettings.productionMode) {
        //    return (<BrowserRouter>
        //        <div>
        //            <UnderConstruction />
        //        </div>
        //    </BrowserRouter>)
        //}

        return (
            <BrowserRouter>
                <div>
                    <header>
                        <CREHeaderContainer />
                    </header>
                    <Route path="/"
                        render={() =>
                            <OnUpdate
                                immediate
                                call={(location) => {
                                    Tracking.trackPageView(location)
                                }} />}
                    />
                    <Route exact path="/" render={props => <Home />} activeClassName="active" />
                    <Route path="/ResourceItem/:id" component={ResourceItemContainer} activeClassName="active" />
                    <Route path="/Resources" component={ResourcesContainer} activeClassName="active" />
                    <Route path="/ProjectItem/:id" component={ResearchItemContainer} activeClassName="active" />
                    <Route path="/Projects" component={ResearchContainer} activeClassName="active" />
                    <Route path="/ProjectDetail" component={ResearchDetail} activeClassName="active" />
                    <Route exact path="/Publications/:id" component={PublicationsContainer} activeClassName="active" />
                    <Route exact path="/Publications" component={PublicationsContainer} activeClassName="active" />
                    <Route path="/News" component={NewsContainer} activeClassName="active" />
                    <Route path="/ContactUs" component={ContactUsContainer} activeClassName="active" />
                    <Route path="/AboutUs" component={AboutUsContainer} activeClassName="active" />
                    <Route path="/DiscussionBoard" component={DiscussionBoardContainer} activeClassName="active" />
                    <Route path="/Mission" component={Mission} activeClassName="active" />
                   
                    <Route path="/OurTeam" component={OurTeamContainer} activeClassName="active" />
                    <Route path="/IndigenousAdvisoryGroup" component={IndigenousAdvisoryGroupContainer} activeClassName="active" />
                    <Route path="/CALDAdvisoryGroup" component={CALDAdvisoryGroupContainer} activeClassName="active" />
                    <Route path="/YouthAdvisoryGroup" component={YouthAdvisoryGroupContainer} activeClassName="active" />
                    <Route path="/ConsumerAdvisoryGroup" component={ConsumerAdvisoryGroupContainer} activeClassName="active" />
                    <Route path="/AdvisoryGroup" component={AdvisoryGroupsContainer} activeClassName="active" />
                    <Route path="/OurLogo" component={AboutLogo} activeClassName="active" />
                    <Route path="/Partners" component={Partners} activeClassName="active" />


                    <Route path='/admin' component={AdministrationContainer} />
                    <footer >
                        <CREFooter />
                    </footer>
                </div>
            </BrowserRouter>
        );
    }
}

/* <Route path="/DiscussionBoard" component={DiscussionBoardContainer} activeClassName="active" />
 <Route path="/Investigators" component={InvestigatorsContainer} activeClassName="active" />
                    <Route path="/Involved" component={Involved} activeClassName="active" />
*/

const appReducer = combineReducers({
    discussionBoard,
    siteData,
    people,
    notification,
    news,
    research,
    publications,
    homeSettings,
    aboutUsSettings,
    contactUsSettings
});

let store = configureStore(appReducer, rootEpic);
store.dispatch(siteDataRequest());


ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>, document.getElementById("app"));




// WEBPACK FOOTER //
// ./src/app.tsx